import React from 'react';
import NavPane from '../../components/NavPane';
import { pages } from './queries';

const PagesMenu = ({ siteId }) => (
  <NavPane query={pages} variables={{ siteId }} dataRoot='pages' urlRoot={`sites/${siteId}/pages`} tree />
);

export default PagesMenu
